module.exports = __webpack_public_path__ + "img/amarillo.47370dbc.svg";